import React from 'react';
import { Head, Link } from '@inertiajs/react';
import DashboardLayout from '../../../components/DashboardLayout';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { FileText } from 'lucide-react';

interface Document {
  id: number;
  title: string;
  policy_type: string;
  updated_at: string;
}

interface IndexProps {
  documents: Document[];
}

const Index: React.FC<IndexProps> = ({ documents }) => {
  return (
    <DashboardLayout>
      <Head title="Legal Documents - Admin" />

      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold">Legal Documents</h1>
          <p className="mt-1 text-sm text-gray-400">
            Manage privacy policy and terms of service content.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {documents.map((doc) => (
            <Card key={doc.id}>
              <CardHeader>
                <div className="flex items-center gap-2">
                  <FileText className="h-5 w-5" />
                  <CardTitle>{doc.title}</CardTitle>
                </div>
                <CardDescription>
                  Type: {doc.policy_type === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                {doc.updated_at && (
                  <p className="text-sm text-muted-foreground">
                    Last updated: {new Date(doc.updated_at).toLocaleDateString()}
                  </p>
                )}
                <Link href={`/admin/legal_documents/${doc.id}/edit`}>
                  <Button className="w-full">Edit Document</Button>
                </Link>
                <div className="flex gap-2">
                  <Link href={doc.policy_type === 'privacy' ? '/privacy' : '/terms'} className="flex-1">
                    <Button variant="outline" className="w-full">View Public Page</Button>
                  </Link>
                </div>
              </CardContent>
            </Card>
          ))}

          {documents.length === 0 && (
            <div className="col-span-2 text-center py-8 text-muted-foreground">
              No legal documents found. Run the migration and seed data first.
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Index;
